import { message } from 'antd';
import Api from '../../../services/Api';
import BusinessModel from '../../FindYourBusiness/models/BusinessModel';
import SiteMapModel from '../../Sitemap/models/SiteMapModel';
import { COLLECT_ALL_AREAS, UPDATE_AREA_TEXT } from '../consts/events';
import EditorStateMachine from '../model/EditorStateMachine';
import SiteBuilderModel from '../model/SiteBuilderModel';
import FrameEventMessanger from './frames/FrameEventMessanger';
import IframeServiceInjector from './injectors/IframeServiceInjector';
import WebsitePreviewCreator from './WebsitePreviewCreator';

export default class TextAiRegenrator {
  public static async regenerateText(
    areaName: string,
    elementId,
    templateId: string | null
  ) {
    try {
      const iframeEventMessanger =
        IframeServiceInjector.getService<FrameEventMessanger>(
          'FrameEventMessanger'
        );

      EditorStateMachine.transition('onElementStartRegeneratingData', {
        elementId
      });

      let textsDataFromPage =
        await iframeEventMessanger.sendMessageAndWaitForResponse(
          COLLECT_ALL_AREAS,
          {}
        );

      const currentSelectedPageTemplate =
        SiteBuilderModel.currentShownInPreviewGeneratedPage.getId();

      const result = await Api.regenerateText(
        areaName,
        templateId  ? 'template' : 'page',
        textsDataFromPage,
        BusinessModel.businessWizardData.category,
        SiteMapModel.getSiteMapFinalTree(),
        SiteBuilderModel.currentShownInPreviewGeneratedPage.getId(),
        WebsitePreviewCreator.collectBusinessData()
      );

      if (
        SiteBuilderModel.currentShownInPreviewGeneratedPage.getId() !==
        currentSelectedPageTemplate
      ) {
        // if the user changed the template while the text was regenerating
        return;
      }

      iframeEventMessanger.sendMessage(UPDATE_AREA_TEXT, {
        areaName,
        regeneratedText: result.data.text
      });
    } catch (e) {
      message.error('Failed to regenerate text');
    } finally {
      EditorStateMachine.transition('onElementFinishRegeneratingData', {
        elementId
      });
    }
  }
}
